import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import {
  ROUTE_CLIENT_EMAIL_CAMPAIGN_CREATE,
} from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function CreateEmailCampaign() {

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        onClick={() => {
          store.dispatch(hideNotification());
          history.push(ROUTE_CLIENT_EMAIL_CAMPAIGN_CREATE);
        }}
        size="sm"
      >
        <FormattedMessage
          id="components.pages.emailCampaigns.actionButtons.create_email_campaign" />
      </Button>
    </Fragment>
  )
}

export { CreateEmailCampaign };
